const AjaxResponse = require('./ajax-response');
const {serialize} = require('object-to-formdata');

const Ajax = {
  /**
   * Makes HTTP request to the server.
   * @param {string} method HTTP method (GET, POST)
   * @param {string} url
   * @param {*|FormData} data
   * @param {function} callback Signature of the callback: `function (error, response)`.
   * If error is null, then success response.
   * @param {XMLHttpRequestResponseType} responseType
   * @return {AjaxResponse}
   */
  request(method, url, data, callback, responseType = 'text') {
    const self = this;

    const ajaxResponse = new AjaxResponse();
    const formData = this._getFormData(data);

    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.responseType = responseType;

    xhr.send(formData);

    xhr.onload = function () {
      self._handleOnLoad(xhr, ajaxResponse, callback);
    };

    xhr.onerror = function () {
      self._handleOnError(ajaxResponse);
    };

    return ajaxResponse;
  },
  _getFormData(data) {
    if (!data) {
      return null;
    }

    let formData = null;

    if (data instanceof FormData) {
      formData = data;
    } else if (data && typeof data === 'object') {
      formData = serialize(data, {indices: true, allowEmptyArrays: false});
    } else {
      console.warn('Wrong post data format. Cannot transform into FormData.');
    }

    return formData;
  },

  _handleOnLoad(xhr, ajaxResponse, callback) {
    if (+xhr.status !== 200) {
      ajaxResponse.runFail(new Error('Error ' + xhr.status + ': ' + xhr.statusText));
    } else {
      if (typeof callback === 'function') {
        callback(xhr.response);
      }

      ajaxResponse.runDone(xhr.response);
    }

    ajaxResponse.runAlways();
  },

  _handleOnError(ajaxResponse) {
    ajaxResponse.runFail(new Error('Request failed'));
    ajaxResponse.runAlways();
  },

  /**
   * Makes POST request
   * @param {string} url
   * @param {*|FormData} data
   * @param {function} callback Signature of the callback: `function (error, response)`.
   * If error is null, then success response.
   * @param {XMLHttpRequestResponseType} responseType
   * @return {AjaxResponse}
   */
  post(url, data, callback, responseType = 'text') {
    return this.request('POST', url, data, callback, responseType)
  },

  /**
   * Makes GET request
   * @param {string} url
   * @param {*|FormData} data
   * @param {function} callback Signature of the callback: `function (error, response)`.
   * If error is null, then success response.
   * @param {XMLHttpRequestResponseType} responseType
   * @return {AjaxResponse}
   */
  get(url, data, callback, responseType) {
    return this.request('GET', url, data, callback, responseType);
  },
};

module.exports = Ajax;
